import React from 'react';
import styled, { css } from 'styled-components';
import Scene from '../scene/scene';
import H5 from '../../modules/lower-ui-kit/components/typography/h5';
import { StyledWithChildrenProps } from '../../modules/lower-ui-kit/types/StyledWithChildrenProps';
import useDocumentTitle from '../../modules/lower-ui-kit/hooks/useDocumentTitle/useDocumentTitle';

type LoginPageProps = {
  title: string;
  pageTitle: string;
  maintenanceMessage: string;
};

function LoginSceneMaintenanceView({
  title,
  pageTitle,
  maintenanceMessage,
}: LoginPageProps) {
  const titlePrefix = 'DocUpload | ';

  useDocumentTitle(`${titlePrefix}${pageTitle}`);

  const maintenanceInfo = process.env.MAINTENANCE_INFO ?? '';

  return (
    <Scene>
      <Container>
        <div>
          <Title>
            {title}
          </Title>
          <Subtitle>
            {maintenanceMessage}
          </Subtitle>
          <MaintenanceInfo>
            {maintenanceInfo}
          </MaintenanceInfo>
        </div>
      </Container>
    </Scene>
  );
}

const Title = styled(H5) < StyledWithChildrenProps > `
  font-weight: bold;
  letter-spacing: -0.32px;
  line-height: 28px;
  font-size: 18px;
  margin-bottom: 14px;
  ${({ theme }) => css`
    color: ${theme.colors.primary};
  `}
`;

const Subtitle = styled(H5) < StyledWithChildrenProps > `
  ${({ theme }) => css`
    font-size: ${theme.maintenanceInfo.fontSize};
    color: ${theme.maintenanceInfo.color};
    margin: ${theme.maintenanceInfo.margin};
  `}
`;

const MaintenanceInfo = styled(H5) < StyledWithChildrenProps > `
  ${({ theme }) => css`
    font-size: ${theme.maintenanceInfo.fontSize};
    color: ${theme.maintenanceInfo.color};
    margin: ${theme.maintenanceInfo.margin};
  `}
`;

const Container = styled.div`
  text-align: center;
  margin-top: 10vmin;
`;

export default LoginSceneMaintenanceView;
